import * as types from "../actions/actionTypes";
import initialState from "./initialState";

export default function roleReducer(state = initialState.role , action) {
    if (action.type === types.READ_ROLES_SUCCESS)
    {
        return action.role;
    }
    else {
        return state;
    }
}
